import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'tfpa.quoteandbind.wizard.step.Policy Details',
        defaultMessage: 'Policy Details',
    },
    effectiveDate: {
        id: 'tfpa.quoteandbind.views.contact-details.Requested Coverage Start Date',
        defaultMessage: 'Requested Coverage Start Date',
    },
    saveModalTitle: {
        id: 'tfpa.quoteandbind.ho.views.policy-info.Please save or cancel',
        defaultMessage: 'Please save or cancel',
    },
    ageValidationError: {
        id: "tfpa.quoteandbind.ho.views.policy-info.ageValidationError",
        defaultMessage: "Age must not be less than 16 years or greater than 120 years."
    },
})